<template>
  <div
    class="modal fade shared-modal"
    id="socilaShareModal"
    tabindex="-1"
    aria-labelledby="socilaShareModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="socilaShareModalLabel">Поделиться:</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body py-4 d-flex justify-content-center align-items-center flex-wrap">
          <template v-for="({ icon, link, styles }) in $options.shared">
            <a class="shared-modal__link d-flex" :key="link" :href="`${link}${articleLink}`" target="_blank" :style="styles">
                <div class="shared-modal__icon" v-html="icon" />
            </a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const fbIcon = `<svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.35196 5.60335L7.19274 7.72346H5.02235V15.0894H2.27374V7.72346H0.807262V5.60335H2.27374V4.94134V4.28771V4.17877C2.27374 3.55028 2.2905 2.58659 2.74302 1.98324C3.22067 1.34637 3.88268 0.918995 5.01397 0.918995C6.85754 0.918995 7.63687 1.17877 7.63687 1.17877L7.26816 3.34916C7.26816 3.34916 6.65642 3.17318 6.08659 3.17318C5.51676 3.17318 5.00559 3.3743 5.00559 3.94413V4.17877V4.94134V5.60335H7.35196Z" fill="#2E76E4"/>
               </svg>`
const vkIcon = `<svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M14.2736 3.60979C12.7455 5.72766 12.5847 5.54 13.8447 6.77319C15.0511 7.95276 15.2923 8.51574 15.3728 8.56936C15.8553 9.45404 14.8098 9.56128 14.8098 9.56128H12.7991C12.5311 9.56128 12.3702 9.61489 11.8072 9.18596C11.0566 8.64979 10.3596 7.22893 9.79659 7.41659C9.23362 7.60425 9.26042 8.89106 9.26042 8.89106C9.26042 8.89106 9.23362 9.21276 9.12638 9.32C8.96553 9.61489 7.81277 9.56128 7.81277 9.56128C7.81277 9.56128 5.82894 9.66851 4.14 7.68468C2.2366 5.59362 0.54766 1.4383 0.54766 1.4383C0.54766 1.4383 0.440426 1.17021 0.54766 1.03617C0.601277 0.928936 0.976596 0.955744 0.976596 0.955744H3.12128C3.12128 0.955744 3.46979 1.03617 3.65745 1.27745C3.95234 1.65277 4.00596 2.21574 4.4617 3.04681C5.34638 4.68213 5.77532 5.05745 6.07021 4.86979C6.52596 4.62851 6.39191 2.56425 6.39191 2.56425C6.39191 2.56425 6.41872 1.81362 6.17745 1.49191C5.98979 1.25064 5.66808 1.17021 5.50723 1.1434C5.37319 1.1166 5.56085 0.821702 5.82894 0.687659C6.17745 0.526808 6.68681 0.5 7.35702 0.5C7.62511 0.5 7.92 0.5 8.21489 0.526808C8.45617 0.553617 8.59021 0.553617 8.75106 0.607234C9.47489 0.821702 9.23362 1.54553 9.23362 3.28808C9.23362 3.85106 9.15319 4.62851 9.52851 4.89659C9.68936 5.00383 10.0915 4.8966 11.1102 3.10042C11.5928 2.26936 11.7 1.70638 11.9413 1.25064C12.0753 1.00936 12.4238 1.00936 12.4238 1.00936H14.6757C14.6757 1.00936 15.3996 0.955745 15.4532 1.17021C15.5604 1.51872 15.1851 2.32298 14.2736 3.60979Z"
                      fill="#2687F5"/>
                </svg> `
const tgIcon = `<svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.008 1.2951L12.7444 11.9702C12.5737 12.7237 12.1283 12.9111 11.4954 12.5563L8.04643 10.0147L6.42457 8.80468C6.17206 8.61629 6.15459 8.24416 6.38833 8.03294L12.3292 2.66464C12.6072 2.41687 12.269 2.27956 11.8973 2.52735L4.38559 7.25718C4.13764 7.41331 3.83369 7.45283 3.55406 7.36531L0.592689 6.43845C-0.147335 6.20738 -0.160704 5.69839 0.7467 5.34348L14.0537 0.216891C14.6698 -0.0141423 15.2089 0.354141 15.008 1.2951Z" fill="#29A9EB"/>
               </svg>`
const vbIcon = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.5495 11.9083C13.1169 12.4312 12.699 12.9817 12.1865 13.4193C11.7466 13.7948 11.1713 13.8401 10.5988 13.608C5.89521 11.7024 2.52171 8.46254 0.57607 3.78666C0.527156 3.66946 0.487621 3.54824 0.446057 3.42827C0.0818674 2.37876 0.191606 1.97108 1.05938 1.26512C1.34297 1.03425 1.64659 0.825252 1.95452 0.626819C2.47203 0.293331 3.04126 0.297355 3.43256 0.765144C4.08288 1.54303 4.7033 2.35688 5.23704 3.21626C5.63544 3.85783 5.49301 4.221 4.90833 4.70413C4.77325 4.81579 4.62828 4.91589 4.49294 5.02731C4.15461 5.30622 4.01167 5.6387 4.16094 6.07983C4.81506 8.01386 6.18008 9.23665 8.08288 9.88628C8.30414 9.96173 8.64983 9.79221 8.89186 9.6559C9.07256 9.55404 9.17849 9.32216 9.31839 9.14863C9.69627 8.67958 10.3076 8.48115 10.8122 8.79879C11.7141 9.36668 12.5784 9.99744 13.4261 10.6435C13.6078 10.7821 13.6519 11.0982 13.75 11.3118C13.6707 11.561 13.6598 11.775 13.5495 11.9083Z" fill="#6C4DBB"/>
                  <path d="M6.86461 0.539297C6.90136 0.383619 7.04404 0.313954 7.06914 0.301631C7.13422 0.269713 7.19232 0.264743 7.30792 0.254856L7.31091 0.2546C7.31091 0.2546 7.41204 0.248061 7.50074 0.250576C10.5161 0.330804 13.1205 2.45522 13.4955 5.67341C13.5206 5.88844 13.5635 6.14271 13.5759 6.66633C13.5784 6.7712 13.5802 6.96159 13.4504 7.08432C13.3919 7.13965 13.3247 7.1643 13.2778 7.17637C13.2127 7.16203 13.1101 7.12934 13.0312 7.04358C12.9268 6.92984 12.919 6.78261 12.9161 6.72784L12.9159 6.72442C12.8843 6.14019 12.8009 5.55646 12.6655 4.98681C12.1642 2.87497 10.2323 1.20829 8.05602 0.966846C7.80309 0.938678 7.5494 0.911013 7.2952 0.899444C7.12286 0.891648 6.95154 0.859959 6.88413 0.745275C6.83593 0.662266 6.85884 0.564036 6.86461 0.539297Z" fill="#6C4DBB"/>
                  <path d="M8.04892 2.5279C8.04335 2.5269 7.92195 2.52614 7.76837 2.48616C7.64748 2.45472 7.5532 2.42881 7.48148 2.34657C7.41356 2.26861 7.39506 2.17304 7.39227 2.10161C7.40773 2.04653 7.44042 1.96379 7.51569 1.90343C7.62188 1.81817 7.75595 1.8232 7.81906 1.82622C9.59641 1.91425 10.6489 2.93558 10.6489 2.93558C10.7402 3.02411 11.1221 3.40287 11.4544 4.01728C11.855 4.7582 11.9706 5.44806 12.0079 5.87058C12.017 5.96691 12.0145 6.10976 11.9475 6.25663C11.9199 6.31699 11.8888 6.38364 11.8155 6.43621C11.7266 6.50009 11.6302 6.50486 11.5889 6.50436C11.5431 6.48726 11.4858 6.45809 11.4354 6.40628C11.3702 6.33938 11.3403 6.26644 11.337 6.23626C11.2432 5.42669 11.1155 4.63597 10.6137 3.95214C9.97657 3.08447 9.07433 2.69993 8.04892 2.5279Z" fill="#6C4DBB"/>
                  <path d="M10.3732 5.60425C10.356 5.83889 10.2599 5.92541 10.2358 5.94578C10.1641 6.00589 10.0812 6.02249 10.0311 6.02802C9.97302 6.0167 9.89065 5.99105 9.82375 5.92541C9.72465 5.82808 9.71198 5.69428 9.70691 5.65052C9.68334 5.44756 9.5366 4.79819 9.20181 4.49865C8.99247 4.31129 8.7033 4.21245 8.28031 4.15158C8.11051 4.12719 7.94578 4.09299 7.88622 3.98132C7.84159 3.89744 7.87079 3.80285 7.88068 3.77083L7.88115 3.7693C7.95059 3.54698 8.22228 3.48285 8.24382 3.47832C8.42426 3.50347 9.57766 3.67977 10.1051 4.53085C10.3904 4.99134 10.3828 5.47321 10.3732 5.60425Z" fill="#6C4DBB"/>
              </svg>`
const okIcon = `<svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.99822 0.75C3.9415 0.75 2.24609 2.41761 2.24609 4.50213C2.24609 6.55886 3.91371 8.25426 5.99822 8.25426C8.08274 8.25426 9.75036 6.58665 9.75036 4.50213C9.75036 2.41761 8.05495 0.75 5.99822 0.75ZM5.99822 5.75284C5.30339 5.75284 4.74751 5.19697 4.74751 4.50213C4.74751 3.80729 5.30339 3.25142 5.99822 3.25142C6.69306 3.25142 7.24894 3.80729 7.24894 4.50213C7.24894 5.19697 6.69306 5.75284 5.99822 5.75284Z" fill="#F6C143"/>
                  <path d="M10.6126 10.7837C9.66763 11.3118 8.63927 11.6731 7.61091 11.8398L10.5292 15.4252C10.8628 15.8421 10.9461 16.4258 10.6404 16.8705C10.1679 17.5931 9.16735 17.6209 8.66706 16.9816L5.97109 13.6742L3.30291 16.9816C3.05276 17.2874 2.71924 17.4263 2.35792 17.4263C1.99661 17.4263 1.63529 17.2596 1.38515 16.9261C1.07942 16.5092 1.10721 15.8143 1.44074 15.3974L4.33127 11.7843C3.30291 11.5897 2.27454 11.2562 1.35736 10.7281C0.773691 10.3946 0.579136 9.67194 0.912659 9.06048C1.24618 8.47682 1.99661 8.28226 2.58027 8.61578C4.69258 9.81091 7.33297 9.81091 9.47308 8.64358C10.0567 8.31005 10.8072 8.5324 11.1129 9.11607C11.4186 9.72753 11.1963 10.4502 10.6126 10.7837Z" fill="#F6C143"/>
               </svg>`


const shared = [
  {
    styles: { borderColor: '#2E76E4' },
    icon: fbIcon,
    link: 'https://www.facebook.com/sharer/sharer.php?u='
  },
  {
    styles: { borderColor: '#2687F5' },
    icon: vkIcon,
    link: 'https://vk.com/share.php?url='
  },
  {
    styles: { borderColor: '#29A9EB' },
    icon: tgIcon,
    link: 'https://t.me/share/url?url='
  },
  {
    styles: { borderColor: '#6C4DBB' },
    icon: vbIcon,
    link: 'viber://forward?text='
  },
  {
    styles: { borderColor: '#F6C143' },
    icon: okIcon,
    link: 'https://connect.ok.ru/offer?url='
  },
]

export default {
  name: "ShareSocialModal",

  data() {
    return {
        link: null,
    }
  },

  mounted() {

    $("#socilaShareModal").on(
        "show.bs.modal", 
        this.handleModalShown
    );

    $("#socilaShareModal").on(
        "hidden.bs.modal", 
        this.handleModalHidden
    );

  },

  shared,

  computed: {

    articleLink(){
      let { href } = window.location
      return  `${href}` + `${this.link ?? ''}`
    }

  },

  methods: {

    handleModalShown(){
        this.link = window.blogSharedLink
    },

    handleModalHidden(){
        $("body").css({ "padding-right": "0" })
        this.link = window.blogSharedLink = null
    }

  }  

};
</script>
